import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar, Tag } from "lucide-react";
import api, { formatDate } from "../lib/api";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";
import AttachmentLink from "../components/AttachmentLink";

export default function AnnouncementDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/announcements/${id}`)
      .then((r) => setItem(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Správa sa nenašla."));
  }, [id]);

  if (error) {
    return (
      <div className="wrap py-20 text-center">
        <div className="eyebrow justify-center mb-4">Chyba</div>
        <h2 className="display-md mb-4">Správa nebola nájdená</h2>
        <p className="text-ink-500 mb-6">{error}</p>
        <Link to="/uradne-spravy" className="btn btn-dark"><ArrowLeft className="w-4 h-4" /> Späť na zoznam</Link>
      </div>
    );
  }

  if (!item) {
    return <div className="wrap py-20 text-ink-500">Načítavam...</div>;
  }

  return (
    <div data-testid="announcement-detail">
      <Seo title={item.title} description={item.excerpt || `${item.category} ${item.number} — úradná správa ObFZ Levice.`} />
      <PageHeader
        eyebrow={`${item.category}${item.number ? " · " + item.number : ""}`}
        title={item.title}
        breadcrumbs={[
          { label: "Úradné správy", to: "/uradne-spravy" },
          { label: item.number || item.title },
        ]}
      >
        <Link to="/uradne-spravy" className="btn btn-outline-white">
          <ArrowLeft className="w-4 h-4" /> Späť
        </Link>
      </PageHeader>

      <section className="section-pad bg-paper">
        <div className="wrap max-w-4xl">
          <div className="flex flex-wrap items-center gap-4 mb-8 border-b-2 border-ink-900 pb-4 mono text-[11px] font-bold uppercase tracking-widest">
            <span className="flex items-center gap-1.5 text-ink-500">
              <Calendar className="w-3.5 h-3.5" /> {formatDate(item.date)}
            </span>
            <span className="flex items-center gap-1.5 text-green-700">
              <Tag className="w-3.5 h-3.5" /> {item.category} {item.number}
            </span>
          </div>

          <article className="bg-white border border-ink-100 p-8 md:p-12">
            <div className="prose-content whitespace-pre-line">{item.content}</div>
            {item.attachment_url && (
              <div className="mt-8 pt-6 border-t border-ink-100">
                <div className="mono text-[11px] font-bold uppercase tracking-widest text-ink-500 mb-3">Príloha</div>
                <AttachmentLink url={item.attachment_url} name={item.attachment_name} />
              </div>
            )}
          </article>
        </div>
      </section>
    </div>
  );
}
